import { render, staticRenderFns } from "./CloseAccount.vue?vue&type=template&id=2680cfbd&"
import script from "./CloseAccount.vue?vue&type=script&lang=js&"
export * from "./CloseAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports